import React, {Dispatch, SetStateAction} from 'react';

type SetShouldShowAudit = Dispatch<SetStateAction<boolean>>;

export type StateForShouldShowAudit = [boolean, SetShouldShowAudit];

export const useShouldShowAudit = (): StateForShouldShowAudit => {
	return React.useState(false);
};
